import React, { useEffect, useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { InputOtp } from "primereact/inputotp";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useFormContext } from "react-hook-form";
import { usePostHog } from "@posthog/react";
import { useSelector } from "react-redux";

function OtpVerficationPopup({ show, onClose, formData, onVerified }) {
  const { watch, setValue } = useFormContext();
  const [timer, setTimer] = useState(60);
  const [token, setTokens] = useState("");
  const [showResend, setShowResend] = useState(false);
  const { order_id } = useParams();

  const { isLoading, postData: otpVerification } = usePostRequest(
    API_ENDPOINTS.VERIFY_PAYMENT_OTP,
  );
  const { postData: resendOtp } = usePostRequest(API_ENDPOINTS.PAYMENT_OTP);
  const user = useSelector((state) => state.auth.user);

  const modalRef = useRef(null);
  const paymentAmount = watch("totalCostAfterMargin");
  console.log("paymentAmount", paymentAmount);
  const posthog = usePostHog();

  const onSuccess = (response) => {
    setValue("customerPaid", "paid");
    posthog.capture("Auth.Net_payment_completed", {
      done_by: user?.email,
    });
    toast.success(response?.message || "Payment verified successfully.");
    setTokens("");
    setTimer(60);
    setShowResend(false);
    if (onVerified) onVerified(response);
    onClose();
  };

  const onError = (error) => {
    toast.error(error?.message || "Failed to verify OTP.");
    setTokens("");
  };

  const handleVerify = () => {
    const payload = {
      // username: formData?.username,
      card_id: formData?.id,
      order_id: order_id,
      otp: token,
      amount: paymentAmount,
      rfq_id: null,
    };
    otpVerification(payload, onSuccess, onError);
  };

  const onSuccessResend = () => {
    toast.success("OTP resent.");
    setTimer(60);
    setShowResend(false);
  };

  const onErrorResend = (error) => {
    toast.error(error?.message || "Failed to resend OTP.");
  };

  const handleResend = () => {
    // resend OTP using existing formData
    const payload = { id: formData?.id, type: "order_payment" };
    resendOtp(payload, onSuccessResend, onErrorResend);
  };

  // Countdown timer
  useEffect(() => {
    let countdown;
    if (show && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(countdown);
            setShowResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(countdown);
  }, [show, timer]);

  // Enter key handler for submit
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && show && token.length === 6 && !isLoading) {
        handleVerify();
      }
    };
    if (show) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [show, token, isLoading]);

  // Focus modal on open
  useEffect(() => {
    if (show && modalRef.current) {
      modalRef.current.focus();
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      className="otp-modal-container"
    >
      <div ref={modalRef} tabIndex={-1}>
        <Modal.Header closeButton className="justify-content-center">
          <Modal.Title>Verify Your Identity</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0 text-center">
          <p>Enter the 6-digit code sent to your email.</p>
          <div className="otp-input-wrapper">
            <InputOtp
              value={token}
              onChange={(e) => setTokens(e.value)}
              length={6}
              integerOnly
            />
          </div>
          <div className="resend-timer-wrapper modal-subtitle mt-3">
            {timer > 0 ? (
              <p className="timer-text">
                Resend code in: <span className="phone-number">{timer}s</span>
              </p>
            ) : (
              showResend && (
                <p className="resend-text">
                  Didn't get code?{" "}
                  <span
                    className="resend-link"
                    style={{ cursor: "pointer" }}
                    onClick={handleResend}
                  >
                    Resend
                  </span>
                </p>
              )
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="warning"
            onClick={handleVerify}
            disabled={isLoading || token.length < 6}
          >
            {isLoading ? "Verifying..." : "Verify"}
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default OtpVerficationPopup;
